// extracted by mini-css-extract-plugin
export var legendIndicator = "_ex-1";
export var legendRight = "_ex-0";